// extracted by mini-css-extract-plugin
export default {"Switch":"Switch-module__Switch__XKbTo","Inline":"Switch-module__Inline__uOnWI","Item":"Switch-module__Item__X2R_D","Selected":"Switch-module__Selected__Gjr_O"};